import React from "react";
import { useQueryValue } from "../../../hooks/useSearch";
import { QUERY_KEY } from "../../../types/query.types";
import Icon from "../icons/Icon";
import "./SearchBox.css";

interface Props {
  placeholder?: string;
  loading?: boolean;
  param: QUERY_KEY;
  style?: React.CSSProperties;
}

export default function SearchBox(props: Props) {

  const {
    param,
    placeholder = "Search...",
    loading,
    style
  } = props;

  const { value, update } = useQueryValue(param);

  return (
    <div className="p-4 ps-3 ps-sm-4 pe-3 pe-sm-4" style={style}>
      <div className="position-relative d-flex flex-row align-items-center gap-2">
        <Icon
          icon="search"
          size={12}
          loading={loading}
          color="var(--gray-400)"
          className="search-box-icon position-absolute top-50 translate-middle-y"
        />
        <input
          className="form-control text-field search-box"
          placeholder={placeholder}
          onChange={(e) => {
            update(e.target.value);
          }}
          value={value}
        />
      </div>
    </div>
  );
} 